import { FC } from "react";
import iconDog from "../assets/images/icon_dog.svg";
import iconCat from "../assets/images/icon_cat.svg";
import iconBunny from "../assets/images/icon_bunny.svg";

const FilterBySpecies: FC<{
  dogFilter: boolean;
  catFilter: boolean;
  critterFilter: boolean;
  handleDogFilterChange: () => void;
  handleCatFilterChange: () => void;
  handleCritterFilterChange: () => void;
}> = ({
  dogFilter,
  catFilter,
  critterFilter,
  handleDogFilterChange,
  handleCatFilterChange,
  handleCritterFilterChange,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-2 mb-2 pl-8 pr-8">
      <div className="text-bold text-2xl whitespace-nowrap pr-4">
        I'm looking for...
      </div>
      <div className="flex flex-col md:flex-row">
        <div
          className={`flex items-center w-full mr-6 ${!dogFilter ? "!text-gray-400" : ""}`}
        >
          <input
            type="checkbox"
            id="checkDogs"
            name="checkDogs"
            checked={dogFilter}
            onChange={handleDogFilterChange}
            className="w-6 h-6 accent-primary rounded mr-2"
          />
          <label htmlFor="checkDogs" className="text-2xl whitespace-nowrap">
            <img
              src={iconDog}
              className="inline-block"
              width="20"
              height="20"
              style={{ opacity: !dogFilter ? 0.5 : 1 }}
            />{" "}
            Dogs
          </label>
        </div>
        <div
          className={`flex items-center w-full mr-4 ${!catFilter ? "!text-gray-400" : ""}`}
        >
          <input
            type="checkbox"
            id="checkCats"
            name="checkCats"
            checked={catFilter}
            onChange={handleCatFilterChange}
            className="w-6 h-6 accent-primary rounded mr-3"
          />
          <label htmlFor="checkCats" className="text-2xl whitespace-nowrap">
            <img
              src={iconCat}
              className="inline-block"
              width="18"
              height="18"
              style={{ opacity: !catFilter ? 0.5 : 1 }}
            />{" "}
            Cats
          </label>
        </div>
        <div
          className={`flex items-center w-full ${!critterFilter ? "!text-gray-400" : ""}`}
        >
          <input
            type="checkbox"
            id="checkCritters"
            name="checkCritters"
            checked={critterFilter}
            onChange={handleCritterFilterChange}
            className="w-6 h-6 accent-primary rounded mr-3"
          />
          <label htmlFor="checkCritters" className="text-2xl whitespace-nowrap">
            <img
              src={iconBunny}
              className="inline-block"
              width="30"
              height="30"
              style={{ opacity: !critterFilter ? 0.5 : 1 }}
            />{" "}
            Critters
          </label>
        </div>
      </div>
    </div>
  );
};

export default FilterBySpecies;
